import { useEffect, useState } from "react";
import i18n from "../../i18n/i18n";
import { Button } from "react-bootstrap";
import { Drawer } from "antd";
import {
  CustomerService,
  deleteCustomerById,
  getCustomerById,
} from "./core/_request";
import {
  initialCustomerPageState,
  CustomerItemData,
  CustomerPageState,
} from "./core/_model";
import { useCustomerListState, useCustomerStore } from "./store/CustomerStore";
import { ActionsKey } from "../../common/models/Actions";
import { ColumnItem } from "../../common/models/table";
import CustomerForm from "./CustomerForm";
import { useNavigate } from "react-router";
import { Loader } from "../../common/components/Loader/Loader";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { API_URLs } from "../../utilities/API_URLs";
import { HttpStatusCode } from "axios";

const cols: ColumnItem[] = [
  {
    key: "reference",
    title: "Référence client",
    dataIndex: "reference",
    // isCanSort: true,
    searchType: "text",
    show: true,
  },
  {
    key: "name",
    title: "Entreprise",
    dataIndex: "name",
    // isCanSort: true,
    searchType: "text",
    show: true,
  },
  {
    key: "address",
    title: "Adresse",
    dataIndex: "address",
    // isCanSort: true,
    show: true,
  },
  {
    key: "customerCategory",
    title: "Type",
    dataIndex: "customerCategory",
    searchKey: "customerCategory",
    searchType: "select",
    selectUri: API_URLs.settings.customers.categoryForSelect,
    show: true,
    render: (state: any) => {
      return (
        <div className="">
          <span> {state?.name} </span>
        </div>
      );
    },
  },
];

const CustomerList = () => {
  const { pageState, setPageState, resetPageState } = useCustomerListState();
  const { customerList, setCustomerList, actioned, setActioned, totalItems } =
    useCustomerStore();
  const Navigate = useNavigate();

  const [openForm, setOpenForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    refreshCustomerList(pageState);
  }, [pageState]);

  const refreshCustomerList = async (newState?: CustomerPageState) => {
    try {
      setIsLoading(true);
      const res = await CustomerService.getAllCustomer(
        newState ?? initialCustomerPageState
      );

      if (res?.status === HttpStatusCode.Ok) {
        setCustomerList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const loadCustomerById = async (
    customer: CustomerItemData,
    action: ActionsKey
  ) => {
    const detail = await getCustomerById(customer["id"]?.toString());
    if (detail) {
      setActioned({ data: detail, action: action });
    }
  };
  const onDeleteCustomerById = async (customer: CustomerItemData) => {
    const deleteResponse = await deleteCustomerById(customer["id"]?.toString());
    refreshCustomerList();
  };
  const onActionClick = (customer: CustomerItemData, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteCustomerById(customer);
    } else {
      if (action === "update") {
        onEditCustomer(customer?.id);
        return;
      }
      loadCustomerById(customer, action);
    }
  };

  const onNewCustomer = () => {
    Navigate("/app/customer/new");
  };

  const onEditCustomer = (id: number) => {
    Navigate(`/app/customer/edit/${id}`);
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Gestion des clients"
        isEnableAdd
        onClickOnAdd={() => onNewCustomer()}
      />
      <div className="py-4">
        <LFTableV3
          columns={cols}
          data={customerList}
          onAction={onActionClick}
          params={pageState}
          isCanEdit={() => true}
          isCanShow={() => true}
          isCanDelete={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onChangePage={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
        />
      </div>
      <Drawer
        open={openForm || actioned !== null}
        placement="right"
        onClose={() => {
          setOpenForm(false);
          setActioned(null);
        }}
        width={"75%"}
        title={
          actioned?.action === "read"
            ? "Détails" /* 
            : actioned?.action === "update"
            ? "Modification" */
            : i18n.t("NEW")
        }
      >
        <CustomerForm
          //onCreated={onSavedCustomer}
          actioned={actioned}
          open={openForm || actioned !== null}
        />
      </Drawer>
    </div>
  );
};

export default CustomerList;
